import {Directive,ElementRef,Renderer,HostListener,Input} from '@angular/core';
import { IDMChucNangTheoQuyen } from '../he-thong/dm-chuc-nang/dm-chuc-nang';

@Directive({ selector: '[vnptQuyen]' })

export class VnptQuyenDirective {
    newString:string = '';
    
    @Input() set vnptQuyen(listItems: IDMChucNangTheoQuyen[]) {
        this.newString  = "";
      
        this.ElementRef.nativeElement.innerHTML = "";
        this.ElementRef.nativeElement.value = null;
        var ds = listItems;
        this.createMenu(ds,0);
        this.newString.replace("<ul></ul>", "");
        this.newString.replace('<ul></ul>', "");        
        this.ElementRef.nativeElement.innerHTML = this.newString;
        //jQuery('.easy-tree').EasyTree({});
        
    }
    constructor(private ElementRef:ElementRef, private Renderer:Renderer ){
        this.ElementRef.nativeElement.innerHTML = "";
    }

    createMenu(listItems:IDMChucNangTheoQuyen[],parent:number){
        
        
        if(listItems.length>0){
            
            this.newString+='<ul>';
            
            for(let i=0;i<listItems.length;i++){
                
                if(listItems[i].IdCha==parent){
                    this.newString +="<li>"+listItems[i].Ten;                    
                    //listDonVi.splice(i, 1);
                    var newParent = listItems[i].Id;
                    
                    this.createMenu(listItems,newParent);
                    this.newString= this.newString+"</li>";
                   
                }
            }
          
            this.newString+='</ul>';
            
        }
        
    }

}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/vnpt-quyen.directive.ts